import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const AccessDenied = ({ message = "Nimate dostopa do te strani." }) => {
  return (
    <Container fluid className="mt-5">
      <Row className="justify-content-center">
        <Col xs="auto" className="text-center">
          <h4 className="text-danger">Dostop zavrnjen</h4>
          <p className="text-muted">{message}</p>
        </Col>
      </Row>
    </Container>
  );
};

export default AccessDenied;
